import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut as firebaseSignOut,
  updateProfile,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
  type User as FirebaseUser,
  type UserCredential,
  type ActionCodeSettings
} from 'firebase/auth'
import { auth, isFirebaseConfigured } from './firebase'

export async function signIn(email: string, password: string) {
  if (!auth) throw new Error('Firebase Auth not configured')
  return signInWithEmailAndPassword(auth, email, password)
}

export async function signUp(email: string, password: string, displayName?: string) {
  if (!auth) throw new Error('Firebase Auth not configured')
  const cred = await createUserWithEmailAndPassword(auth, email, password)
  if (displayName && cred.user) {
    await updateProfile(cred.user, { displayName })
  }
  return cred
}

export async function signInWithGoogle(): Promise<UserCredential> {
  if (!auth) throw new Error('Firebase Auth not configured')
  const provider = new GoogleAuthProvider()
  provider.setCustomParameters({ prompt: 'select_account' })
  return signInWithPopup(auth, provider)
}

export async function signOut() {
  if (!auth) return
  await firebaseSignOut(auth)
  localStorage.removeItem('currentUserId')
  localStorage.removeItem('activeOrgId')
}

export function getCurrentUser(): FirebaseUser | null {
  return auth?.currentUser ?? null
}

export function isAuthConfigured(): boolean {
  return isFirebaseConfigured()
}

// --- Magic link (email link) auth for participants ---

const PARTICIPANT_EMAIL_KEY = 'participantEmailForSignIn'

export async function sendParticipantMagicLink(email: string, redirectUrl: string): Promise<void> {
  if (!auth) throw new Error('Firebase Auth not configured')
  const actionCodeSettings: ActionCodeSettings = {
    url: redirectUrl,
    handleCodeInApp: true
  }
  await sendSignInLinkToEmail(auth, email, actionCodeSettings)
  window.localStorage.setItem(PARTICIPANT_EMAIL_KEY, email)
}

export function isParticipantSignInLink(url: string): boolean {
  if (!auth) return false
  return isSignInWithEmailLink(auth, url)
}

export async function completeParticipantSignIn(url: string, email?: string): Promise<UserCredential> {
  if (!auth) throw new Error('Firebase Auth not configured')
  const storedEmail = email || window.localStorage.getItem(PARTICIPANT_EMAIL_KEY)
  if (!storedEmail) throw new Error('No se encontró el email. Por favor introduce tu email.')
  const credential = await signInWithEmailLink(auth, storedEmail, url)
  window.localStorage.removeItem(PARTICIPANT_EMAIL_KEY)
  return credential
}
